export const types = {
  TOGGLE_TOOL_EXT: "TOGGLE_TOOL_EXT"
};
